<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'PRODUCT_CATEGORY.UPDATE_CATEGORY_TITLE' | translate }}
    </h3>
    <form
      [formGroup]="product_category_update_category_from_group"
      class="sp-margin__top-x2">
      <!-- Name -->
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'PRODUCT_CATEGORY.NAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="name"
          required />
      </mat-form-field>

      <!-- Decido Code -->
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'PRODUCT_CATEGORY.DECIDO_CODE_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="decido_evaluation_code"
          required />
      </mat-form-field>

      <!-- Confirm Button -->
      <app-shared-button
        class="sp-width__full sp-margin__top"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_submit_running"
        [is_spinner_visible]="is_submit_running"
        (click)="onSubmitClick()"></app-shared-button>
    </form>
  </div>
</div>
